import * as type from '@/utvStore/store/mutation-types'
import { DIALOG_STAT } from '@/CONSTS'

const initialState = {
  seelaterInfoStat: 0
}

const state = Object.assign({}, initialState)

const getters = {}

const actions = {
  [type.NOTIFY_SEELATER_ADDED]({ commit }, stat) {
    commit(type.NOTIFY_SEELATER_ADDED, stat)
  }
}

const mutations = {
  [type.NOTIFY_SEELATER_ADDED](_state, stat) {
    _state.seelaterInfoStat = stat
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/modules/dialogs.js